export default "int x = 20, y = 10;\n\nvar result = x > y ? x : y;\n\nConsole.WriteLine(result);\n"